/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type AuthUserInput = {
    email: string;
    password: string;
};
export type LoginUserMutationVariables = {
    input: AuthUserInput;
};
export type LoginUserMutationResponse = {
    readonly authUser: {
        readonly user: {
            readonly id: string;
            readonly email: string;
            readonly firstName: string | null;
            readonly lastName: string | null;
            readonly role: string | null;
            readonly salesforceId: string | null;
            readonly companyName: string;
        } | null;
        readonly token: string | null;
        readonly error: string | null;
    };
};
export type LoginUserMutation = {
    readonly response: LoginUserMutationResponse;
    readonly variables: LoginUserMutationVariables;
};



/*
mutation LoginUserMutation(
  $input: AuthUserInput!
) {
  authUser(input: $input) {
    user {
      id
      email
      firstName
      lastName
      role
      salesforceId
      companyName
    }
    token
    error
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AuthUserPayload",
    "kind": "LinkedField",
    "name": "authUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "salesforceId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyName",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "token",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LoginUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LoginUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c539f7fa87192440222e0977808449e9",
    "id": null,
    "metadata": {},
    "name": "LoginUserMutation",
    "operationKind": "mutation",
    "text": "mutation LoginUserMutation(\n  $input: AuthUserInput!\n) {\n  authUser(input: $input) {\n    user {\n      id\n      email\n      firstName\n      lastName\n      role\n      salesforceId\n      companyName\n    }\n    token\n    error\n  }\n}\n"
  }
};
})();
(node as any).hash = '13e8d766b0c1ba3a7cb30be5b4f30f29';
export default node;
